import React from 'react'
import { T } from '@transifex/react'
import { formatCurrencyValue } from '@vend/utilities'
import { useAppSelector } from '../../../state/hooks'
import {
  selectSaleFinals,
  selectSaleStatus,
  selectLineItems,
} from '../../../state/slices/currentSale/currentSaleSlice'
import {
  useRetailerSettingsManager,
  useRegisterManager,
} from '../../../ng-compat/hooks'
import { isQuote } from '../../../functions/sale'
import { getBasketSize } from '../../../functions/lineItem'

export const SaleTotalSection = () => {
  const saleStatus = useAppSelector(selectSaleStatus)
  const saleFinals = useAppSelector(selectSaleFinals)
  const lineItems = useAppSelector(selectLineItems)
  const basketSize = getBasketSize(lineItems)
  const retailer = useRetailerSettingsManager().get()
  const registerManager = useRegisterManager()
  const currentOutlet = registerManager.getActiveOutlet()

  return (
    <section className="sale-summary-section sale-summary-section-divider-top sale-summary-section-divider-btm">
      <ul className="sale-summary-list">
        <li className="sale-summary-line sale-summary-line--total">
          <div className="sale-summary-line-item sale-summary-line-item--label">
            <span className="vd-text-signpost">
              {isQuote(saleStatus) ? (
                <T
                  _str="QUOTE TOTAL"
                  _context="Quote total label in sale summary"
                />
              ) : (
                <T
                  _str="SALE TOTAL"
                  _context="Sale total label in sale summary"
                />
              )}
            </span>
            <span className="vd-text-supplementary">
              <T
                _str="{itemCount, plural, one { {itemCount} item} other { {itemCount} items}}"
                _context="Item count in sale summary"
                itemCount={basketSize}
              />
            </span>
          </div>
          <div className="sale-summary-line-item sale-summary-line-item--value vd-text-intro">
            {formatCurrencyValue(
              saleFinals.inclusivePrice,
              retailer.culture,
              currentOutlet.currency,
              currentOutlet.currency_symbol
            )}
          </div>
        </li>
      </ul>
    </section>
  )
}
